import { Inject, Injectable, Optional } from '@angular/core';
import { App } from '@df/core/app';
import { CookiesService } from '@df/core/service/cookies';
import { Status } from '@df/core/status';
import { TimeoutService } from '@df/ng/timeout.service';
import { BodyClassService } from '@df/ui/body-class.service';
import { NPwa } from './pwa.interface';
import { PWA_OPTIONS } from './pwa.options';
import { pwaForcedStandaloneCookie, isPwaStandaloneCookie, isPwaStandalone, isPwaStandalonForced } from './pwa-const';

@Injectable({
    providedIn: 'root'
})
export class PwaIntegrationService {
    /**
     * If PWA is availble on the website
     */
    readonly isAvailable: boolean = false;

    /**
     * Toggling status
     * when you switch between pwa (forced) and normal
     */
    readonly toggleStatus = new Status();

    private isStandalonForced = isPwaStandalonForced;

    /**
     * If applications is standalone (PWA version)
     */
    isStandalone = isPwaStandalone;

    /**
     * Dependencies
     */
    constructor(
        private app: App,
        private cookieService: CookiesService,
        private timeoutService: TimeoutService,
        private bodyClassService: BodyClassService,
        @Optional() @Inject(PWA_OPTIONS) options: NPwa.IModuleOptions
    ) {
        if (app.isPlatformBrowser) {
            // we consider PWA set on a website if PWA module (that providesd PWA options) is installed
            this.isAvailable = !!options;
            if (this.isStandalone) {
                this.bodyClassService.add('is-standalone', this);
                this.cookieService.set(isPwaStandaloneCookie, '1');
            } else {
                this.cookieService.set(isPwaStandaloneCookie, '0');
            }
        }
    }

    /**
     * Toggle forced standalone mode
     * Either sets pretended standalone mode on or of
     */
    toggleForcedStandalone(to = !this.isStandalone) {
        if (to !== this.isStandalonForced && this.app.isPlatformBrowser) {
            this.toggleStatus.busy = true;
            if (to) {
                this.cookieService.set(pwaForcedStandaloneCookie, '1');
            } else {
                this.cookieService.delete(pwaForcedStandaloneCookie);
            }

            this.timeoutService.setTimeout(() => {
                window.location.reload();
            }, 1000);
            return true;
        } else {
            this.toggleStatus.error = 'Forced PWA mode is already ' + (to ? 'on' : 'off');
        }
    }
}
